import axios, { AxiosResponse } from "axios";
import { URL_ORQUESTRADOR } from "shared/util/perfis/exportEnvs";

export type UsuarioTour = {
  deveExibirVisaoGeralTour: boolean;
  deveExibirArrecadacaoTour: boolean;
  deveExibirContaPagarTour: boolean;
  deveExibirModalInformativo: boolean;
  deveExibirModalBemVindoGroupPay: boolean;
  usuarioId: number;
};

export const setUsuarioTour = () => {
  return axios.get(`${URL_ORQUESTRADOR}/api/usuario-tour`).then((resp: AxiosResponse<UsuarioTour>) => {
    localStorage.setItem("usuarioTour", JSON.stringify(resp.data));
    window.dispatchEvent(new Event("changeUsuarioTour"));
  });
};

export const getUsuarioTour = () => {
  if (localStorage.getItem("usuarioTour")) {
    return JSON.parse(localStorage.getItem("usuarioTour") || "{}");
  }
  return null;
};

export const updateUsuarioTour = (usuarioTour: UsuarioTour) => {
  axios.put(`${URL_ORQUESTRADOR}/api/usuario-tour`, usuarioTour).then((resp: AxiosResponse<UsuarioTour>) => {
    localStorage.setItem("usuarioTour", JSON.stringify(resp.data));
    window.dispatchEvent(new Event("changeUsuarioTour"));
  });
};

export const settarTourFalse = (atributoUsuarioTour: string) => {
  let usuarioTour = getUsuarioTour();
  usuarioTour[atributoUsuarioTour] = false;
  updateUsuarioTour(usuarioTour);
};
